import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { Account } from './account/index';
import { RuleFields } from './customField';
import { row } from './utils';
import { useStyles } from './styles';

const RuleForm = props => {
  const classes = useStyles();

  return (
    <Grid container item xs={row} classes={{ root: classes.EventTypeForm }}>
      <RuleFields rule={props.rule} selectOptions={props.selectOptions} />
      <Account
        rule={props.rule}
        transactionType="debit"
        selectOptions={props.selectOptions}
      />
      <Account
        rule={props.rule}
        transactionType="credit"
        selectOptions={props.selectOptions}
      />
    </Grid>
  );
};

RuleForm.propTypes = {
  selectOptions: PropTypes.object,
  rule: PropTypes.object,
};

export default React.memo(RuleForm);
